import { Node, mergeAttributes } from '@tiptap/core'

// Inline FontAwesome icon, insertable mid-paragraph from the builder toolbar (ENG-30779).
// Like the standalone Icon element (Builder::Elements::IconComponent) it is a bare <i class="...">,
// but it also carries the FA class string as a data attribute,
// the latter so parseHTML can round-trip it back into the node attribute on reload.
export const FaIcon = Node.create({
  name: 'faIcon',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addOptions() {
    return { HTMLAttributes: { class: 'inline-fa-icon' } }
  },

  addAttributes() {
    return {
      faClasses: {
        default: 'fa-solid fa-star',
        parseHTML: (element) => element.getAttribute('data-fa-classes'),
        renderHTML: (attributes) => ({
          'data-fa-classes': attributes.faClasses,
          class: attributes.faClasses,
        }),
      },
    }
  },

  parseHTML() {
    // Priority above the default 50: Italic's own `i` parse rule (@tiptap/extension-italic) has
    // no priority either, and ProseMirror's DOMParser tries mark rules before node rules at equal
    // priority — so without this, every saved `<i data-fa-classes>` would be claimed by Italic
    // first and reload as an empty italic mark instead of an icon.
    return [{ tag: 'i[data-fa-classes]', priority: 51 }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'i',
      mergeAttributes(
        { 'aria-hidden': 'true' },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
    ]
  },

  addCommands() {
    return {
      insertFaIcon:
        (faClasses) =>
        ({ chain, state }) =>
          chain()
            // At the start of the selection, not over it: the floating toolbar only shows for a
            // non-empty selection, so insertContent would delete the text the user selected.
            .insertContentAt(state.selection.from, [
              { type: this.name, attrs: { faClasses } },
              // Zero-width space after the icon, matching mention.js/chat_bot_skill.js's
              // insertion convention, so the cursor has somewhere to type immediately after
              // an atom node without needing white-space: pre-wrap.
              { type: 'text', text: ' ​' },
            ])
            .run(),
    }
  },
})
